import { SxProps, Theme } from "@mui/material";

export const tableStyles = {
  wrapper: {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: "12px",
    overflow: "hidden",
    bgcolor: "background.paper",
  } as SxProps<Theme>,

  requiredLabel: {
    color: "error.main",
  } as SxProps<Theme>,

  addButton: {
    borderRadius: "8px",
    textTransform: "none",
  } as SxProps<Theme>,

  dataGrid: {
    border: "none",
    height: 400,
    "& .MuiDataGrid-columnHeaders": {
      borderBottom: "1px solid",
      borderColor: "divider",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 500,
      letterSpacing: "0.05em",
    },
    "& .MuiDataGrid-cell": {
      alignItems: "flex-start",
      py: 1,
      overflow: "visible",
    },
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid",
      borderColor: "divider",
    },
    "& .row-has-issue": {
      borderLeft: "3px solid",
      borderLeftColor: "warning.main",
      bgcolor: "rgba(255, 152, 0, 0.05)",
      "&:hover": {
        bgcolor: "rgba(255, 152, 0, 0.1) !important",
      },
    },
  } as SxProps<Theme>,

  footer: {
    borderTop: "1px solid",
    borderColor: "divider",
  } as SxProps<Theme>,

  reviewButton: {
    borderRadius: "8px",
    textTransform: "none",
  } as SxProps<Theme>,
};
